<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white self-center"><b>
                    {{ aprPiRecord?.stringShortName }}
                </b></div>
        </div>

        <div class="p-12">
            <form [formGroup]="aprForm">
                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Well String</mat-label>
                        <input matInput formControlName="stringShortName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Activity Type</mat-label>
                        <input matInput formControlName="activity" disabled />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Record Date</mat-label>
                        <input matInput [matDatepicker]="startPicker" formControlName="recordDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                    </mat-form-field>

                    <div class="col-span-2">
                        <mat-label style="font-weight: 500; color: #313b4c">Record Time</mat-label>
                        <input matInput class="input input-bordered w-full" type="time" formControlName="recordTime" />
                    </div>

                    <mat-form-field class="col-span-2">
                        <mat-label>THP</mat-label>
                        <input matInput formControlName="thp" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Annulus Pressure Reading (PCP)</mat-label>
                        <input matInput formControlName="annAPress" />
                        <span matTextSuffix>psi</span>
                    </mat-form-field>
    
                    <mat-form-field class="col-span-4">
                        <mat-label>Remarks</mat-label>
                        <textarea matInput formControlName="remarks"></textarea>
                    </mat-form-field>
                </div>


            </form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="back()">
            Back
        </button>
    </div>
</div>